import { AuthService } from '@app/core/authentication';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { CustomUtils } from './customUtils';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MessServiceService } from '../services/mess-service.service';
import { VisibilityObject } from '../models/visibility.model';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  seoFieldsArray = ['slug', 'meta_title', 'meta_keywords', 'meta_description'];
  appConfig: any;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private messService: MessServiceService,
    private authService: AuthService,
    private store: Store<any>
  ) {
    this.subscriptions.push(
      store.select('config').subscribe((res) => {
        this.appConfig = res;
      })
    );
  }

  checkPermissions(route) {
    return {
      delete: route.snapshot.data['permissions']?.delete?.includes(
        this.authService.userValue.data.role
      ),
      update: route.snapshot.data['permissions']?.update?.includes(
        this.authService.userValue.data.role
      ),
      create: route.snapshot.data['permissions']?.create?.includes(
        this.authService.userValue.data.role
      ),
    };
  }

  checkPermissionsFromObject(permissionsObject) {
    return {
      delete: permissionsObject?.delete?.includes(
        this.authService.userValue.data.role
      ),
      update: permissionsObject?.update?.includes(
        this.authService.userValue.data.role
      ),
      create: permissionsObject?.create?.includes(
        this.authService.userValue.data.role
      ),
    };
  }

  throwToastErrors(form: FormGroup, error: any) {
    const errorObj = error.error.errors;
    const messService = this.messService;

    Object.keys(errorObj).forEach(function (key) {
      const formControl = form.get(key);
      if (formControl) {
        /**
         * If error exist set red border to field
         */
        formControl.setErrors({});
        formControl.markAsDirty();
      }
      /**
       * Push toast error for every field
       */
      messService.addError({
        detail: errorObj[key][0],
        sticky: false,
      });
    });
  }

  patchLangForm(form: FormGroup, data: any, fields: any) {
    let fieldsArray: any[] = [];

    fields.forEach((field: any) => {
      if (field.controlType === 'page-seo') {
        fieldsArray = fieldsArray.concat(this.seoFieldsArray);
      }
      if (field.dummyFields) {
        field.dummyFields.forEach((dummyField: any) => {
          fieldsArray.push(dummyField.options.formControlName);
        });
      }
      // Check if this is group of dields
      if (field.group) {
        // Loop group of fields
        field.group.forEach((singleField: any) => {
          fieldsArray.push(singleField.options.formControlName);
        });
      } else {
        if (field.options) {
          fieldsArray.push(field.options?.formControlName);
        }
      }
    });

    this.appConfig.languages.forEach((lang: any) => {
      fieldsArray.forEach((field, index) => {
        CustomUtils.getLangFormGroup(form, lang.code).patchValue({
          [`${field}`]: data.locale[lang.code]?.[`${field}`] || '',
        });
      });
    });
  }

  patchForm(form: FormGroup, data: any, fields: any) {
    let fieldsArray: any[] = [];

    fields?.forEach((field: any) => {
      if (field.controlType === 'page-seo') {
        fieldsArray = fieldsArray.concat(this.seoFieldsArray);
      }
      if (field.dummyFields) {
        field.dummyFields.forEach((dummyField: any) => {
          fieldsArray.push(dummyField.options.formControlName);
        });
      }
      // Check if this is group of dields
      if (field.group) {
        // Loop group of fields
        field.group.forEach((singleField: any) => {
          fieldsArray.push(singleField.options.formControlName);
        });
      } else {
        if (field.options) {
          fieldsArray.push(field.options?.formControlName);
        }
      }
    });

    fieldsArray.forEach((field, index) => {
      form.patchValue({
        [`${field}`]:
          data[`${field}`] !== undefined && data[`${field}`] !== null
            ? data[`${field}`]
            : '',
      });
    });
  }

  /**
   * * FILES
   */
  appendFilesToRequest(fileList: any[], fd, fdKey: string) {
    fileList.forEach((file) => {
      if (file.originalFile != null && file.delete != true) {
        fd.append(fdKey, file.originalFile);
      }
    });
  }
  appendFilesToForm(
    fileList: any[],
    form,
    fd,
    formKey: string,
    options: { multiple: boolean }
  ) {
    if (options?.multiple) {
      form[formKey] = fileList;
    } else {
      const images = fileList.filter((file) => !file?.delete);
      if (images.length === 0) {
        form[formKey] = fileList[0];
      } else {
        form[formKey] = fileList.filter((file) => !file?.delete)[0];
      }
    }
  }

  patchFiles(fileList: any[], files): any {
    if (!files) return [];

    if (Array.isArray(files)) {
      files.forEach((file) => {
        fileList.push({
          ...file,
          originalFile: null,
          imageLocalUrl: file?.url,
        });
      });
    } else {
      fileList.push({
        ...files,
        originalFile: null,
        imageLocalUrl: files?.url,
      });
    }
  }

  addDropdownOptions({
    fields,
    dropdownName,
    dropdownOptions,
  }: {
    fields: any[];
    dropdownName: string;
    dropdownOptions: any[];
  }) {
    fields.forEach((fieldGroup) => {
      if (fieldGroup.group) {
        fieldGroup?.group.forEach((fieldElement) => {
          if (fieldElement.options.formControlName === dropdownName) {
            fieldElement.options.dropdownOptions = dropdownOptions;
          }
        });
      } else {
        if (fieldGroup.options.formControlName === dropdownName) {
          fieldGroup.options.dropdownOptions = dropdownOptions;
        }
      }
    });
  }

  mapVisibilityObject(visibleBy) {
    console.log(
      '%cIZVRSAVA SE FUNKCIJA',
      'background-color: #e0005a ; color: #ffffff ; font-weight: bold ; padding: 4px ;'
    );
    const mappedObject = {
      user_ids: visibleBy.user_ids.map((user) => user.user_id),
      sale_point_ids: visibleBy.sale_point_ids.map(
        (salePoint) => salePoint.sale_point_id
      ),
      retailer_ids: visibleBy.retailer_ids.map(
        (retailer) => retailer.retailer_id
      ),
    };

    return mappedObject;
  }

  patchVisibility(visibilityData): VisibilityObject {
    if (visibilityData) {
      return {
        raw: visibilityData.visibility,
        fullData: visibilityData.visibility_checklist,
        isVisibleByAll: visibilityData.is_visible_by_all,
      };
    } else {
      return {
        raw: {
          retailer_ids: [],
          sale_point_ids: [],
          user_ids: [],
        },
        fullData: {
          retailer_ids: [],
          sale_point_ids: [],
          user_ids: [],
        },
        isVisibleByAll: false,
      };
    }
  }
}
